import { Validators } from '@quickbit/qb-design-system';
import { Merchant } from '../types';

export const merchantValidators: Validators<Merchant, Merchant> = {
  countryCode: (code: string) =>
    code.length < 1 ? 'Can not be empty.' : undefined,
};
